export default momentRun

/** @ngInject */
function momentRun(amMoment) {
    amMoment.changeLocale('fr')
}



// WEBPACK FOOTER //
// ./src/config/moment.js